export default {
  '320*380': 'In most devices, the AOD (Always-On Display) feature works properly, but on the Amazfit Bip 5, AOD is not available as it does not support the ALWAYS-ON feature.'
} as any
